import React, { useState } from 'react';

const SupportButton = ({ sponsorshipId, onSupport }) => {
  const [responsibilitiesAccepted, setResponsibilitiesAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const RESPONSIBILITY_TEXT = `Le parrain a pour mission de présenter son filleul à l'association, de l'informer des règles de fonctionnement et de faciliter son intégration. Il est moralement responsable du comportement de son filleul lors des activités. En cas de manquement grave du filleul, et s'il est établi que le parrainage a été accordé avec une légèreté manifeste, le Conseil d'Administration pourra prendre des mesures à l'encontre du parrain.`;

  const handleSupport = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`/api/v1/sponsorships/${sponsorshipId}/support`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          accept_responsibilities: true
        })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        if (onSupport) {
          onSupport(data.data.sponsorship);
        }
      } else {
        setError(data.message || 'Une erreur est survenue');
      }
    } catch (err) {
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="alert alert-success">
        ✓ Vous soutenez maintenant cette demande de parrainage !
      </div>
    );
  }

  return (
    <div style={{ background: '#fff', borderRadius: 24, border: '1px solid rgba(124,40,55,0.12)', boxShadow: '0 18px 44px rgba(124,40,55,0.08)', padding: '24px 26px' }}>
        {/* Responsabilités */}
        <div className="card mb-3" style={{ backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 18 }}>
          <div className="card-header" style={{ backgroundColor: '#ffedd5', borderBottom: '1px solid #fed7aa' }}>
            <h5 className="card-title mb-0" style={{ color: '#9a3412', fontWeight: 800 }}>
              Responsabilités du Parrain
            </h5>
          </div>
          <div className="card-body">
            <p 
              className="mb-0" 
              style={{ 
                fontSize: '0.9rem', 
                lineHeight: '1.6',
                color: '#3E2723'
              }}
            >
              {RESPONSIBILITY_TEXT}
            </p>
          </div>
        </div>

        {/* Checkbox d'acceptation */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="responsibilitiesCheckbox"
            checked={responsibilitiesAccepted}
            onChange={(e) => setResponsibilitiesAccepted(e.target.checked)}
          />
          <label className="form-check-label fw-bold" htmlFor="responsibilitiesCheckbox">
            Je comprends et j'accepte mes responsabilités en tant que parrain.
          </label>
        </div>

        {/* Erreur */}
        {error && (
          <div className="alert alert-danger mb-3" role="alert">
            {error}
          </div>
        )}

        {/* Bouton de soutien */}
        <div className="d-grid">
          <button
            type="button"
            className="btn btn-lg"
            style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', color: '#fff', border: 'none', borderRadius: 14, fontWeight: 700 }}
            disabled={!responsibilitiesAccepted || loading}
            onClick={handleSupport}
          >
            {loading ? 'Soutien en cours...' : 'Soutenir ce Parrainage'}
          </button>
        </div>
    </div>
  );
};

export default SupportButton;